<template>
    <div class="row">
        <div class="col-2 paginate_elements">
            <span v-if="false"><!--            <span v-if="this.totalElements > 0">-->
                {{this.from}} to {{this.to}} of all {{this.totalElements}} elements
            </span>
        </div>
        <div class="col-8 paginate_complex">
            <PageBtn @movePage="movePage" :page="{movePage: 0, dispPage: '1'}" :disabled="response.first" :class="'direction first_prev'"/>
            <PageBtn @movePage="movePage" :page="{movePage: response.number-1, dispPage: response.number-1}" :disabled="response.first" :class="'direction prev'"/>
            <template v-for="page in pageList">
                <PageBtn @movePage="movePage" :page="page" :selected="page.selected"/>
            </template>
            <PageBtn @movePage="movePage" :page="{movePage: response.number+1, dispPage: response.number+1}" :disabled="response.last" :class="'direction next'"/>
            <PageBtn @movePage="movePage" :page="{movePage: response.totalPages-1, dispPage: response.totalElements}" :disabled="response.last" :class="'direction last_next'"/>
        </div>
    </div>
</template>

<script>
import PageBtn from "@/components/common/pagination/PageBtn.vue";

export default {
	name: 'PaginationBox',
	components: {PageBtn},
	emits: ['movePage'],
	props: {
		response: {
			type: Object
		},
		pageCount: {
			type: Number
		}
	},
	watch: {
		async response() {
			await this.makePageList(this.response, this.pageCount);
		},
		async pageCount() {
			await this.makePageList(this.response, this.pageCount);
		},
	},
	data() {
		return {
			pageList: {},
            from: 0,
            to: 0,
            totalElements: 0,
		}
	},
	methods: {
        calculateFirstOffset() {
            if(this.response.pageable !== undefined) {
                if(this.response.pageable.pageSize < this.response.totalElements){
                    this.to = this.response.pageable.offset+this.response.pageable.pageSize;
                }else {
                    this.to = this.response.totalElements;
                }

                if(this.response.pageable.offset !== undefined) {
                    this.from = this.response.pageable.offset + 1;
                }

                this.totalElements = this.response.totalElements;
            }
        },
		movePage(page) {
			this.$emit('movePage', page);
		},
		async makePageList(response, pageCount) {
            this.calculateFirstOffset();
			let {pageStt, pageEnd} = await this.calcPage(response.number+1, pageCount, response.totalPages);

			let pageList = [];
			for(let page = pageStt; page <= pageEnd; page++) {
				let movePage = page - 1;
				pageList.push({
					movePage: movePage,
					dispPage: page,
					selected: movePage === response.number
				})
			}

			this.pageList = pageList;
		},

		async calcPage(curPage, pageCount, totalPages) {
			let pageStt;
			let pageEnd;
			if (curPage % pageCount === 0) pageStt = curPage - pageCount + 1;
			else pageStt = pageCount - (curPage % pageCount) + curPage - pageCount + 1;
			pageEnd = Math.min(Number(pageStt) + Number(pageCount) - 1, totalPages);

			return {
				pageStt: pageStt,
				pageEnd: pageEnd,
			}
		},
	},
	async created() {
		await this.makePageList(this.response, this.pageCount);
	}
}
</script>